import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "anchor-float" }
const _hoisted_2 = { class: "af-mini-head" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "af-count" }
const _hoisted_5 = {
  key: 0,
  class: "af-bar"
}
const _hoisted_6 = {
  key: 0,
  class: "st cd",
  title: "当前房间CD"
}
const _hoisted_7 = {
  class: "st available",
  title: "可用"
}
const _hoisted_8 = {
  class: "st cooling",
  title: "冷却中"
}
const _hoisted_9 = {
  class: "st reusable",
  title: "可复用"
}
const _hoisted_10 = {
  class: "st used",
  title: "已使用"
}
const _hoisted_11 = {
  key: 0,
  class: "af-dots-line"
}
const _hoisted_12 = { class: "af-dots af-dots-focus" }
const _hoisted_13 = ["title"]
const _hoisted_14 = {
  key: 0,
  class: "af-dot-n"
}
const _hoisted_15 = {
  key: 1,
  class: "af-dot-cd"
}
const _hoisted_16 = { class: "af-dots" }
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 0,
  class: "af-dot-n"
}
const _hoisted_19 = {
  key: 1,
  class: "af-dot-cd"
}
const _hoisted_20 = {
  key: 1,
  class: "af-dots-empty"
}
const _hoisted_21 = { class: "anchor-float" }
const _hoisted_22 = {
  key: 0,
  class: "af-modal"
}
const _hoisted_23 = { class: "af-panel" }
const _hoisted_24 = { class: "af-head" }
const _hoisted_25 = { class: "af-title" }
const _hoisted_26 = { class: "af-room2" }
const _hoisted_27 = { class: "af-meta" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "af-grid"
}
const _hoisted_30 = ["title"]
const _hoisted_31 = {
  key: 0,
  class: "a-cur"
}
const _hoisted_32 = { class: "a-rs" }
const _hoisted_33 = { class: "a-dl" }
const _hoisted_34 = { class: "a-dl-name" }
const _hoisted_35 = {
  key: 0,
  class: "a-cnt"
}
const _hoisted_36 = { class: "a-win" }
const _hoisted_37 = ["data-cd"]
const _hoisted_38 = {
  key: 1,
  class: "af-empty"
}

import { ref, computed, watch, onMounted, onUnmounted } from 'vue';
import Config from '@/ts/Config';


export default /*@__PURE__*/_defineComponent({
  __name: 'AnchorFloatPanel',
  props: {
    room: {},
    roomName: {},
    embedded: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const room = ref(props.room);

// 跟随玩家所在房间：room 变化立即重连推送（切房间 = 换 room 参数重连，服务端即刻推一帧）
// 注意：首连放在 onMounted，否则 immediate 会在 setup 阶段同步调用 connect()，
// 那时下面的 let/const（es/data）还没初始化，会抛 "Cannot access 'es' before initialization"
watch(
  () => props.room,
  (v) => { room.value = v || ''; connect(); }
);

const STATE_LABEL: Record<string, string> = {
  available: '可用', cooling: '冷却中', reusable: '可复用', used: '已使用', pending: '待结算', raw: '原始'
};
const WIN_PRIMARY: Record<string, string> = { Zhuang: '庄', Xian: '闲', He: '和' };
const WIN_EXTRA: Record<string, string> = {
  ZhuangDui: '庄对', XianDui: '闲对', Da: '大', Xiao: '小', RenYiDui: '任意对', WanMeiDui: '完美对'
};

function winParts(raw: string) {
  let key = 'None', primary = '', text = '未结算';
  if (raw && raw !== 'None') {
    const extras: string[] = [];
    for (const n of raw.split(',').map((s) => s.trim()).filter(Boolean)) {
      if (WIN_PRIMARY[n]) { key = n; primary = WIN_PRIMARY[n]; }
      else if (WIN_EXTRA[n]) extras.push(WIN_EXTRA[n]);
    }
    text = (primary || '未结算') + (extras.length ? '+' + extras.join('+') : '');
  }
  return { key, primary, text };
}

// ===== 数据拉取（走 SSE 推送，和流程追踪同一条 auxStream；后端只在状态变化时推一帧）=====
const data = ref<any>(null);
const open = ref(false);
const fetchedAt = ref(0);
const clock = ref(0); // 每秒自增，驱动 CD 本地倒计时重渲染

const points = computed(() => data.value?.points || []);
const count = computed(() => data.value?.count ?? 0);
const reuseEnabled = computed(() => !!data.value?.reuseEnabled);
const cooldownSeconds = computed(() => data.value?.cooldownSeconds ?? 0);
const currentCd = computed(() => data.value?.currentCd ?? null);
const roomLabel = computed(() => props.roomName || props.room || '未进房');

// 小地图「焦点双段式」：焦点段 = 当前位置 ±3；最新段 = 末尾最近几个
const currentIndex = computed(() => points.value.findIndex((p: any) => p.isCurrent));
const hasCurrent = computed(() => currentIndex.value >= 0);

const focusPoints = computed(() => {
  const arr = points.value;
  if (!arr.length) return [];
  let start: number, end: number;
  if (hasCurrent.value) {
    start = Math.max(0, currentIndex.value - 3);
    end = Math.min(arr.length, currentIndex.value + 4); // 含 +3 ⇒ 末尾 index+3，slice 末位 index+4
  } else {
    start = Math.max(0, arr.length - 7);
    end = arr.length;
  }
  return arr.slice(start, end);
});

const focusIndices = computed(() => new Set(focusPoints.value.map((p: any) => p.index)));

// 最新段：末尾 5 个中剔除已出现在焦点段的，避免和焦点段重复
const latestPoints = computed(() => {
  const arr = points.value;
  return arr
    .slice(Math.max(0, arr.length - 5))
    .filter((p: any) => !focusIndices.value.has(p.index));
});

const counts = computed(() => {
  const c: Record<string, number> = { available: 0, cooling: 0, reusable: 0, used: 0, pending: 0, raw: 0 };
  for (const p of points.value) c[resState(p)] = (c[resState(p)] || 0) + 1;
  return c;
});

// ---- SSE 连接：跟随房间，切房间 = 重连（URL 带 room，连上即推该房间状态）----
let es: EventSource | null = null;
let esFails = 0;
let fallbackTimer: number | null = null;
// 重连定时器必须持有引用：否则组件卸载后它仍会触发 connect()，
// 建出一条没人关闭的 SSE（服务端并发名额只增不减，32 次后所有监控页面 503）。
let retryTimer: number | null = null;
// 连接代号：每次 connect() 递增。旧连接排队中的 aux/onerror 回调一律作废，
// 否则旧连接的 onerror 会把刚建好的新连接 disconnect() 掉（切房后反复闪断）。
let esGen = 0;
// 组件已卸载标记：卸载后禁止任何回调再建连接。
let disposed = false;

function clearRetry() {
  if (retryTimer != null) { clearTimeout(retryTimer); retryTimer = null; }
}

function connect() {
  if (disposed) return;
  clearRetry();                 // 同一时刻只允许存在一个待触发的重连（防定时器堆积/重连风暴）
  const gen = ++esGen;          // 让上一条连接的在途回调失效
  disconnect();
  if (!room.value) { data.value = null; return; }
  // scope=anchors：只要锚点。服务端据此跳过 trace 全量快照与 5 个聚合，
  // 且同一房间的所有遥控器复用同一帧（内容完全一致）。
  const url = `${Config.ORIGIN}/trace/api/auxStream?room=${encodeURIComponent(room.value)}&scope=anchors`;

  let source: EventSource;
  try {
    source = new EventSource(url);
  } catch {
    es = null;
    scheduleFallback();
    return;
  }
  es = source;

  source.addEventListener('aux', (ev: MessageEvent) => {
    if (gen !== esGen) return;  // 旧连接迟到的帧：丢弃
    esFails = 0;
    let d: any;
    try { d = JSON.parse(ev.data); } catch { return; }
    if (d.error) return;
    // aux 帧里带着 anchors；拿到就渲染（服务端只在内容变化时推，缺字段保持原样）
    if (d.anchors) { data.value = d.anchors; fetchedAt.value = Date.now(); }
  });

  let errored = false;
  source.onerror = () => {
    // 旧连接的错误直接忽略：它不能去关掉当前这条（可能是切房后新建的）连接
    if (gen !== esGen || errored) return;
    errored = true;
    // 断线（服务未起 / 旧版本无接口 / 进程重启）：自动重连 + 带鉴权 fetch 兜底
    disconnect();
    esFails++;
    scheduleFallback();

    const delay = Math.min(1000 * esFails, 5000);
    clearRetry();
    retryTimer = window.setTimeout(() => {
      retryTimer = null;
      if (disposed || gen !== esGen) return;   // 已卸载 / 已被新连接取代
      if (!es && room.value) connect();
    }, delay);
  };
}

function disconnect() {
  if (es) { es.close(); es = null; }
}

// 推送连不上时，最多每 10s 用带鉴权的 fetch 拉一次兜底；推送一旦恢复立即停用
function scheduleFallback() {
  if (disposed || fallbackTimer != null) return;
  fallbackTimer = window.setTimeout(() => {
    fallbackTimer = null;
    if (disposed || es) return;
    pollOnce();
    scheduleFallback();
  }, 10000);
}

async function pollOnce() {
  if (disposed || !room.value) return;
  try {
    const url = `${Config.ORIGIN}/trace/api/anchors?room=${encodeURIComponent(room.value)}`;
    const token = localStorage.getItem('auth_token');
    const headers: Record<string, string> = {};
    if (token) headers['X-Auth-Token'] = token;
    const r = await fetch(url, { headers });
    if (!r.ok) return;
    data.value = await r.json();
    fetchedAt.value = Date.now();
  } catch {
    /* 静默 */
  }
}

const cdTimer = window.setInterval(() => { clock.value++; }, 1000);

// 首连：放到 onMounted，确保所有 let/const 已初始化（避免 TDZ）
onMounted(() => { connect(); });

function toggle() {
  open.value = !open.value;
}

// ===== 小地图拖拽（pointer 事件，桌面/触屏通用；拖动时不触发展开）=====
const miniEl = ref<HTMLElement | null>(null);
const miniPos = ref<{ left: number; top: number } | null>(null); // 拖过后用显式 left/top 固定
const miniStyle = computed(() =>
  miniPos.value
    ? { left: miniPos.value.left + 'px', top: miniPos.value.top + 'px' }
    : {}
);

let dragging = false;
let moved = false;
let startX = 0;
let startY = 0;
let offX = 0;
let offY = 0;

function onMiniDown(e: PointerEvent) {
  if (props.embedded) return; // 嵌入总控面板时，拖拽交给总控面板处理，自身不抢拖拽
  if (!miniEl.value) return;
  dragging = true;
  moved = false;
  startX = e.clientX;
  startY = e.clientY;
  const rect = miniEl.value.getBoundingClientRect();
  if (!miniPos.value) miniPos.value = { left: rect.left, top: rect.top };
  offX = e.clientX - rect.left;
  offY = e.clientY - rect.top;
  window.addEventListener('pointermove', onMiniMove);
  window.addEventListener('pointerup', onMiniUp);
}

function onMiniMove(e: PointerEvent) {
  if (!dragging) return;
  if (Math.abs(e.clientX - startX) > 3 || Math.abs(e.clientY - startY) > 3) moved = true;
  let left = e.clientX - offX;
  let top = e.clientY - offY;
  // 限制在视口内，避免拖出屏幕
  left = Math.max(0, Math.min(left, window.innerWidth - 60));
  top = Math.max(0, Math.min(top, window.innerHeight - 40));
  miniPos.value = { left, top };
}

function onMiniUp() {
  dragging = false;
  window.removeEventListener('pointermove', onMiniMove);
  window.removeEventListener('pointerup', onMiniUp);
}

// 点击：仅当没有拖动过才展开/收起
function onMiniClick() {
  if (moved) { moved = false; return; }
  open.value = !open.value;
}

// ===== 渲染辅助 =====
function dotWinClass(p: any) { return 'w-' + winParts(p.winAreas).key; }
function cardClass(p: any) {
  const w = winParts(p.winAreas);
  const cls = ['acard', 'w-' + w.key, 'is-' + resState(p)];
  if (p.isCurrent) cls.push('is-current');
  return cls;
}
function winText(p: any) { return winParts(p.winAreas).text; }
// 复用关闭时「用过就是废了」：不必等自身 CD 走完才置灰，直接按「已使用」渲染。
// （服务端 state 在 CD 内会给 cooling，那是给"允许复用"口径用的；复用关闭就没"复活"这回事）
function isDead(p: any) { return !reuseEnabled.value && !!p.isUsed; }
function resState(p: any) { return isDead(p) ? 'used' : p.state; }
function showCd(p: any) {
  void clock.value; // 建立依赖，使 CD 每秒重算
  return !isDead(p) && p.selfRemainingCd != null;
}
function liveCd(p: any) {
  if (p.selfRemainingCd == null) return 0;
  const dt = (Date.now() - fetchedAt.value) / 1000;
  return Math.max(0, p.selfRemainingCd - dt);
}
function cdValue(p: any) { return p.selfRemainingCd != null ? liveCd(p) : ''; }
// 小地图头部用的「房间当前 CD」实时倒计时（与大面板头部 currentCd 一致）
const currentCdLive = computed(() => {
  void clock.value;
  if (currentCd.value == null) return 0;
  const dt = (Date.now() - fetchedAt.value) / 1000;
  return Math.max(0, Math.round(currentCd.value - dt));
});
// 小地图色豆上叠加的「自身剩余 CD」秒数（复用关闭=已废弃则不显示）
function dotCdNum(p: any) {
  void clock.value;
  if (p.selfRemainingCd == null || isDead(p)) return 0;
  const v = liveCd(p);
  return v > 0 ? Math.ceil(v) : 0;
}
function cdLabel(p: any) {
  void clock.value;
  if (!isDead(p) && p.selfRemainingCd != null) {
    const v = liveCd(p);
    return v > 0 ? 'CD ' + Math.ceil(v) + 's' : (STATE_LABEL[resState(p)] || resState(p));
  }
  return STATE_LABEL[resState(p)] || resState(p);
}
function formatCd(v: number) {
  return v > 0 ? Math.ceil(v) + 's' : '—';
}

function dotTitle(p: any) {
  return `${p.ju}-${p.rs} ${winText(p)} · ${STATE_LABEL[resState(p)] || resState(p)}` +
    (p.isCurrent ? ' · 当前播放位置' : '') +
    (isDead(p) ? ' · 已废弃(复用关闭)' : '') +
    (p.isHe ? ' · 和局(不参与复用)' : '');
}
function cardTitle(p: any) {
  return `局 ${p.ju}-${p.rs}\n荷官 ${p.dealer}\n输赢 ${winText(p)}\n` +
    `判定 ${STATE_LABEL[resState(p)] || resState(p)}（按整局聚合）\n` +
    (isDead(p) ? '※ 复用已关闭：用过即废弃，不再等冷却\n' : '') +
    (p.isHe ? '※ 和局不参与复用：用过即作废（可用一次）\n' : '') +
    `自身已用=${p.isUsed} · 本条复用 ${p.useCount} 次 · 整局复用 ${p.roundUseCount} 次\n` +
    (p.isCurrent ? '★ 当前播放位置（杀猪跳转后即目标局）\n' : '') +
    `自身CD ${p.selfRemainingCd != null ? '剩余 ' + p.selfRemainingCd + 's' : (p.selfUsedAgoSeconds != null ? '已结束（' + p.selfUsedAgoSeconds + 's前用过）' : '未用过')}`;
}

onUnmounted(() => {
  disposed = true;
  esGen++;            // 让所有在途回调（aux / onerror / 重连）失效
  clearRetry();       // 关键：不清的话定时器会在卸载后触发 connect()，建出一条永远没人关闭的 SSE
  disconnect();
  if (fallbackTimer != null) { clearTimeout(fallbackTimer); fallbackTimer = null; }
  clearInterval(cdTimer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["af-mini", { embedded: _ctx.embedded }]),
          ref_key: "miniEl",
          ref: miniEl,
          style: _normalizeStyle(miniStyle.value),
          onPointerdown: onMiniDown,
          onClick: onMiniClick
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", {
              class: "af-room",
              title: _ctx.roomName || room.value || '未进房'
            }, _toDisplayString(roomLabel.value), 9, _hoisted_3),
            _createElementVNode("span", _hoisted_4, _toDisplayString(count.value) + " 锚", 1),
            (points.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (currentCdLive.value > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, "CD " + _toDisplayString(currentCdLive.value) + "s", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(counts.value.available), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(counts.value.cooling), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(counts.value.reusable), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(counts.value.used), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          (points.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[2] || (_cache[2] = _createElementVNode("span", {
                  class: "af-ico ico-focus",
                  title: "焦点：当前跳转点前后各 3 个"
                }, "◎", -1)),
                _createElementVNode("div", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(focusPoints.value, (p) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: 'f' + p.index,
                      class: _normalizeClass(["af-dot", [dotWinClass(p), 'is-' + resState(p), { 'is-current': p.isCurrent }]]),
                      title: dotTitle(p)
                    }, [
                      (p.roundUseCount > 0 && dotCdNum(p) === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_14, "×" + _toDisplayString(p.roundUseCount), 1))
                        : _createCommentVNode("", true),
                      (dotCdNum(p) > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(dotCdNum(p)), 1))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_13))
                  }), 128))
                ]),
                (latestPoints.value.length)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "af-sep" }, null, -1)),
                      _cache[1] || (_cache[1] = _createElementVNode("span", {
                        class: "af-ico ico-latest",
                        title: "最新：末尾最近几个"
                      }, "✦", -1)),
                      _createElementVNode("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(latestPoints.value, (p) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: 'l' + p.index,
                            class: _normalizeClass(["af-dot", [dotWinClass(p), 'is-' + resState(p), { 'is-current': p.isCurrent }]]),
                            title: dotTitle(p)
                          }, [
                            (p.roundUseCount > 0 && dotCdNum(p) === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_18, "×" + _toDisplayString(p.roundUseCount), 1))
                              : _createCommentVNode("", true),
                            (dotCdNum(p) > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(dotCdNum(p)), 1))
                              : _createCommentVNode("", true)
                          ], 10, _hoisted_17))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, "无锚点"))
        ], 38))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", _hoisted_21, [
        (open.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _createElementVNode("div", {
                class: "af-mask",
                onClick: toggle
              }),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _cache[3] || (_cache[3] = _createTextVNode(" 锚点状态 ")),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.roomName || room.value || '未进房'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", null, "复用" + _toDisplayString(reuseEnabled.value ? '开' : '关'), 1),
                    _createElementVNode("span", null, "冷却 " + _toDisplayString(cooldownSeconds.value) + "s", 1),
                    (currentCd.value != null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_28, "当前CD " + _toDisplayString(formatCd(currentCd.value)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("span", null, "共 " + _toDisplayString(count.value), 1)
                  ]),
                  _createElementVNode("span", {
                    class: "af-close",
                    onClick: toggle
                  }, "✕")
                ]),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "af-legend" }, [
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw w-Zhuang" }),
                    _createTextVNode("庄")
                  ]),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw w-Xian" }),
                    _createTextVNode("闲")
                  ]),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw w-He" }),
                    _createTextVNode("和")
                  ]),
                  _createElementVNode("span", { class: "lg-sep" }),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw is-available" }),
                    _createTextVNode("可用")
                  ]),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw is-cooling" }),
                    _createTextVNode("冷却")
                  ]),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw is-reusable" }),
                    _createTextVNode("可复用")
                  ]),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw is-used" }),
                    _createTextVNode("已用")
                  ]),
                  _createElementVNode("span", { class: "lg" }, [
                    _createElementVNode("i", { class: "sw is-current" }),
                    _createTextVNode("当前")
                  ])
                ], -1)),
                (points.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(points.value, (p) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: p.index,
                          class: _normalizeClass(["acard", cardClass(p)]),
                          title: cardTitle(p)
                        }, [
                          (p.isCurrent)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_31, "当前"))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(p.ju) + "-" + _toDisplayString(p.rs), 1),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("span", _hoisted_34, _toDisplayString(p.dealer || '-'), 1),
                            (p.roundUseCount > 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_35, "×" + _toDisplayString(p.roundUseCount), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_36, _toDisplayString(winText(p)), 1),
                          _createElementVNode("div", {
                            class: _normalizeClass(["a-cd", { live: showCd(p) }]),
                            "data-cd": cdValue(p)
                          }, _toDisplayString(cdLabel(p)), 11, _hoisted_37)
                        ], 10, _hoisted_30))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_38, "该房间暂无锚点（未开启杀猪或无数据时为空）"))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]))
  ]))
}
}

})